// extracted by mini-css-extract-plugin
module.exports = {"modulePreset":"ModulePreset__modulePreset__sCBEm"};